module.exports = __webpack_public_path__ + "media/images/donation/how-to-use4-90589c8f3c6349c2b4cccccbb673bae0.jpg";